// @packages
import React, { useState } from 'react';
import {
  Alert,
  Image,
  ScrollView,
  Pressable,
  View
} from 'react-native';
import { Outlet, useNavigate, useMatch } from 'react-router-native';
import { useTheme } from '@rneui/themed';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import AwesomeAlert from 'react-native-awesome-alerts';

// @scripts
import useStyles from './styles';
import { routes } from '../../../core/routes/config';
import { useAuth } from '../../../core/context/provider';
import { config } from '../../../core/config';

const MainLayout = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { onLogout, user } = useAuth();
  const isDashboardPage = useMatch(routes.dashboard.path);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const goBack = () => {
    navigate(-1);
  };

  return (
    <View
      style={[styles.container, { backgroundColor: theme.colors.background }]}
    >
      <View>
        {!isDashboardPage && (
          <Pressable style={styles.backButton} onPress={goBack} testID="Back">
            <MaterialCommunityIcons name="arrow-left" color="black" size={25} />
          </Pressable>
        )}
        <Image style={styles.image} source={require('../../../../assets/logo.png')} />
        {!!user?.siteIds?.length && (
          <Pressable style={styles.logoutItem} onPress={() => setShowAlert(true)} testID="Logout">
            <MaterialCommunityIcons name="logout" size={25} />
          </Pressable>
        )}
      </View>
      <ScrollView showsVerticalScrollIndicator={false} nestedScrollEnabled>
        <Outlet />
      </ScrollView>
      <AwesomeAlert
        show={showAlert}
        showProgress={false}
        title={config.text.common.hey}
        message={config.text.common.doYouWantLogout}
        closeOnTouchOutside
        closeOnHardwareBackPress={false}
        showCancelButton
        showConfirmButton
        cancelText={config.text.common.cancel}
        confirmText={config.text.common.confirm}
        onCancelPressed={() => {
          setShowAlert(false);
        }}
        onConfirmPressed={() => {
          onLogout();
          setShowAlert(false);
        }}
      />
    </View>
  );
};

MainLayout.defaultProps = {
  isAllowed: true
};

export default MainLayout;
